//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required,
  minValue,
  maxValue,
} from 'vuelidate/lib/validators';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import PredictionMixin from '@/components/mixins/prediction.mixin.js';

export default {
  name: 'MusicDurationAdjuster',
  mixins: [AiToolsMixin, PredictionMixin, featureFlagMixin],
  components: {
    ToolImageLayout: () => import('@/components/core/ToolImageLayout.vue'),
    SourceAudio: () => import('@/components/tools/SourceAudio.vue'),
    SelectButtons: () => import('@/components/tools/SelectButtons.vue'),
  },
  data() {
    return {
      faClock,
      form: {
        model: 'music_duration',
        audio: null,
        fileDuration: null,
        duration: null,
      },
      demoAudio: null,
      isFileLoading: false,
      price: false,
      isPriceLoading: false,
      prediction: {
        model: 'music_duration',
        audio: null,
        fileDuration: null,
        duration: null,
      },
      demoAudioItems: [
        {
          value: 'sample_1',
          title: `${this.$t('term.sample')} 1`,
        },
        {
          value: 'sample_2',
          title: `${this.$t('term.sample')} 2`,
        },
      ],
    };
  },
  validations: {
    form: {
      audio: {
        required: required,
      },
      fileDuration: {
        required: required,
        minValue: minValue(15),
        maxValue: maxValue(300), // 5 min
      },
      duration: {
        required: required,
        minValue: minValue(15),
        maxValue: maxValue(300), // 5 min
      },
    },
  },
  watch: {
    'form.audio'(val) {
      if (val) {
        this.error = null;
        this.demoAudio = null;
        this.isFileLoading = true;
        const audio = new Audio(val);

        audio.addEventListener('loadedmetadata', () => {
          this.form.fileDuration = Math.floor(audio.duration);
          this.isFileLoading = false;
          this.tryToEstimate();
        });

        audio.addEventListener('error', () => {
          this.isFileLoading = false;
          console.error('Unable to load audio. Please check the URL.');
        });
      } else {
        this.isFileLoading = false;
        this.form.duration = null;
      }
    },
    'form.duration'(val) {
      if (val) {
        this.tryToEstimate();
      }
    },
  },
  computed: {
    tool() {
      return this.aiTools.find(({ id }) => id === this.aiToolsIds.MUSIC_DURATION_ADJUSTER);
    },
    isSamePrediction() {
      return _.isEqual(this.form, this.prediction);
    },
    formattedTime() {
      const minutes = Math.floor(this.form.duration / 60)
          .toString()
          .padStart(2, '0');
      const seconds = (this.form.duration % 60).toString().padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    demoOutput() {
      switch (this.demoAudio) {
        case 'sample_1':
          return [
            { url: 'https://static.moele.me/img/studio-ai/adjust_music_duration/epic-cinematic-00_35-medium-fade-1.wav' },
            { url: 'https://static.moele.me/img/studio-ai/adjust_music_duration/epic-cinematic-00_35-medium-fade-2.wav' },
            { url: 'https://static.moele.me/img/studio-ai/adjust_music_duration/epic-cinematic-00_35-medium-fade-3.wav' },
          ];
        case 'sample_2':
          return [
            { url: 'https://static.moele.me/img/studio-ai/adjust_music_duration/cute-bright-01_00-long-fade-1.wav' },
            { url: 'https://static.moele.me/img/studio-ai/adjust_music_duration/cute-bright-01_00-long-fade-2.wav' },
            { url: 'https://static.moele.me/img/studio-ai/adjust_music_duration/cute-bright-01_00-long-fade-3.wav' },
          ];
        default:
          return null;
      }
    },
    demoOutputOriginal() {
      switch (this.demoAudio) {
        case 'sample_1':
          return 'https://static.moele.me/img/studio-ai/adjust_music_duration/epic-cinematic-original.wav';
        case 'sample_2':
          return 'https://static.moele.me/img/studio-ai/adjust_music_duration/cute-bright-original.wav';
        default:
          return null;
      }
    },
    estimateParams() {
      return {
        input: {
          filename: this.form.audio.split('/').pop(),
          url: this.form.audio,
          duration: this.form.fileDuration,
        },
        output: {
          duration: this.form.duration,
        },
      };
    },
  },
  methods: {
    onFileUpload() {
      this.clearOldPrediction();
    },
    handleDurationInput(event) {
      // Remove all non-numeric characters
      const rawValue = event.target.value.replace(/[^0-9]/g, '');

      // Ensure the value is not longer than 4 digits
      const sanitizedValue = rawValue.slice(0, 4);

      // Split into minutes and seconds
      const minutes = sanitizedValue.slice(0, -2) || '0';
      const seconds = sanitizedValue.slice(-2) || '0';

      // Calculate the new total seconds
      // eslint-disable-next-line radix
      const totalSeconds = parseInt(minutes) * 60 + parseInt(seconds);

      // Validate against maxDuration
      const maxDuration = _.get(this.$v, 'form.duration.$params.maxValue.max');
      const minDuration = _.get(this.$v, 'form.duration.$params.minValue.min');

      if (totalSeconds > maxDuration) {
        this.form.duration = maxDuration;
      } else if (totalSeconds < minDuration) {
        this.form.duration = minDuration;
      } else {
        this.form.duration = Math.round(totalSeconds);
      }

      // Update the input field with the formatted value
      event.target.value = this.formattedTime;
    },
    clearForm() {
      this.form.audio = null;
      this.form.duration = null;
      this.form.fileDuration = null;
      this.price = false;
      this.demoAudio = null;
    },
    setFormFromResponse(response) {
      console.log(response);
      this.form.audio = _.get(response, 'input.input.url');
      this.form.duration = _.get(response, 'input.output.duration');
      this.form.fileDuration = _.get(response, 'input.input.duration');
      this.prediction.audio = _.get(response, 'input.input.url');
      this.prediction.duration = _.get(response, 'input.output.duration');
      this.prediction.fileDuration = _.get(response, 'input.input.duration');
    },
    tryToEstimate() {
      if (!this.form.duration) {
        return;
      }
      this.getPredictionEstimate(this.estimateParams);
    },
  },
};
